import HttpMethodType from "HttpMethodType";
import SubSystemType from "SubSystemType";
import BaseServiceRequest from "BaseServiceRequest";

class GetAiStatisticsRequest extends BaseServiceRequest {
  constructor(payload) {
    super();
    super.addRequestUri("aiStatistics.pb");
    super.addRequestParameter("symbol", payload.symbol);
    super.addRequestParameter("periodicity", payload.periodicity);
    if (payload.startDate !== null){
      super.addRequestParameter("startDate", payload.startDate);
    }
    if (payload.endDate !== null){
      super.addRequestParameter("endDate", payload.endDate);
    }
  }

  getMethod() {
    return HttpMethodType.GET;
  }

  getSubSystem() {
    return SubSystemType.GRAPH;
  }

  getMessageName() {
  return "AiStatisticResponse";
  }
}

export default GetAiStatisticsRequest;
